import { configureStore } from '@reduxjs/toolkit';

import { rootReducer } from './reducers';
import { loggerMiddleware } from './middleware/logger';

// Create the Redux store
const store = configureStore({
  reducer: rootReducer,
  // Enable Redux DevTools in development
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializability checks
        ignoredActions: ['makeTraffic/initTaskManager/fulfilled'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.makeTrafficManager'],
        // Ignore these paths in the state
        ignoredPaths: ['makeTraffic.makeTrafficManager']
      }
    }).concat(loggerMiddleware)
});

// Infer the `RootState` type from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Export the store's dispatch type
export type AppDispatch = typeof store.dispatch;

export default store;
